import { useEffect, useState } from "react";
import {
  Stack,
  Card,
  CardContent,
  Typography,
  TableContainer,
  TableBody,
  TableCell,
  TableRow,
  Table,
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import Scrollbar from "../../../components/Scrollbar";
import TagsListHead from "../../adm/tags/components/TagsListHead";
import courtesyService from "../../adm/courtesy/services/CourtesyService";

const TABLE_HEAD_SEND = [
  { id: "data", label: "Data", alignRight: false },
  { id: "name_Lens", label: "Tratamento", alignRight: false },
  { id: "totalCourtesy", label: "Total", alignRight: false },
  { id: "type", label: "Tipo", alignRight: false },
  { id: "obs", label: "Observação", alignRight: false },
];

const TABLE_HEAD_MORE = [
  { id: "name_Lens", label: "Tratamento", alignRight: false },
  { id: "totalCourtesy", label: "Total", alignRight: false },
  { id: "approvedCourtesy", label: "Total utilizada", alignRight: false },
];

const TABLE_HEAD_HISTORIC = [
  { id: "updated_at", label: "Data", alignRight: false },
  { id: "code_Order", label: "Código", alignRight: false },
  { id: "name_Lens", label: "Tratamento", alignRight: false },
];

export default function CourtesyClient() {
  const [value, setValue] = useState(0);
  const [clientData, setClientData]: any = useState({});
  const [sendData, setSendData]: any = useState([]);
  const [historicData, setHistoricData]: any = useState([]);
  const [moreData, setMoreData]: any = useState([]);

  useEffect(() => {
    courtesyService
      .getClientHimSelf()
      .then((data: any) => {
        setClientData(data.data);
        setSendData(data.data?.send || []);
        setHistoricData(data.data?.courtesies || []);
        setMoreData(data.data?.clients || []);
      })
      .catch((error: any) => console.error(error));
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const NoItemsFound = () => (
    <TableRow>
      <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
        <Stack width="100%" justifyContent="center" alignItems="center">
          <Typography mt={1} variant="body1" noWrap sx={{ color: "#909090" }}>
            Nenhum item encontrado...
          </Typography>
        </Stack>
      </TableCell>
    </TableRow>
  );

  return (
    <Card sx={{ minWidth: "70vw", overflow: "auto" }}>
      <CardContent>
        <Typography variant="h4" mb={3} color="#004A78" gutterBottom>
          Minhas Cortesias
        </Typography>

        <Tabs
          value={value}
          onChange={handleChange}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            mb: 3,
            "& .MuiTab-root": {
              fontWeight: 600,
              color: "#004A78",
            },
          }}
        >
          <Tab label="Cortesias Enviadas" />
          <Tab label="Cortesias Utilizadas" />
          <Tab label="Resumo Geral" />
        </Tabs>

        {/* Cortesias Enviadas */}
        {value === 0 && (
          <Card>
            <Scrollbar>
              <TableContainer>
                <Table>
                  <TagsListHead headLabel={TABLE_HEAD_SEND} />
                  <TableBody>
                    {sendData?.length ? (
                      sendData.map((row: any, index: number) => (
                        <TableRow hover key={index}>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.updated_at_formatted}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.name_Lens}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.num_courtesies}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.type}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.observation}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <NoItemsFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Card>
        )}

        {/* Cortesias Utilizadas */}
        {value === 1 && (
          <Card>
            <Scrollbar>
              <TableContainer>
                <Table>
                  <TagsListHead headLabel={TABLE_HEAD_HISTORIC} />
                  <TableBody>
                    {historicData?.length ? (
                      historicData.map((row: any, index: number) => (
                        <TableRow hover key={index}>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.updated_at_formatted}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.code_Order}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.name_Lens}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <NoItemsFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Card>
        )}

        {/* Resumo Geral */}
        {value === 2 && (
          <Card>
            <Scrollbar>
              <TableContainer>
                <Table>
                  <TagsListHead headLabel={TABLE_HEAD_MORE} />
                  <TableBody>
                    {moreData?.length ? (
                      moreData.map((row: any, index: number) => (
                        <TableRow hover key={index}>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.name_Lens}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.totalCourtesy}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography
                              variant="subtitle2"
                              noWrap
                              sx={{ color: "#004A78", fontSize: "14px" }}
                            >
                              {row.approvedCourtesy}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <NoItemsFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          </Card>
        )}
      </CardContent>
    </Card>
  );
}
